'use strict';

module.exports = function (selector) {
    return document.querySelector(selector);
};



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/getNodeFromSelector.js
// module id = 14
// module chunks = 0 1